import { DEFAULT_LANG, type Lang } from '@/i18n';

/**
 * Constantes de marque. NeverZero vit sur son propre domaine, séparé de
 * podawaa.com : rien ici ne doit pointer vers Podawaa côté visiteur.
 */
export const SITE_NAME = 'NeverZero';
export const SITE_TAGLINE = 'LinkedIn Growth Agency';

/**
 * Le bouton « Parler à l'équipe » (header et hero) mène ici. `null` = bouton
 * masqué : une agence qui affiche un rendez-vous qu'on ne peut pas prendre est
 * pire qu'une agence sans rendez-vous. Stephen prend les appels sur `/call`,
 * qui retombe sur une demande de rappel quand l'agenda n'est pas lisible : le
 * bouton mène donc toujours quelque part.
 */
export const BOOK_CALL_URL: string | null = '/call';

/**
 * Origine canonique du site.
 *
 * Volontairement vide par défaut : écrire ici un domaine qu'on ne possède pas
 * encore ferait pointer les balises `canonical` et `og:url` de toutes les pages
 * (et le sitemap) vers une adresse fausse, ce qui est pire que pas de canonical.
 * En production, `NEVERZERO_SITE_URL` est renseignée ; sinon le serveur SSR
 * retombe sur l'origine de la requête, qui est toujours juste.
 */
export const CONFIGURED_SITE_URL = (typeof process !== 'undefined' ? process.env?.NEVERZERO_SITE_URL : '') || '';

export function resolveOrigin(requestOrigin?: string): string {
  return (CONFIGURED_SITE_URL || requestOrigin || '').replace(/\/+$/, '');
}

export function absoluteUrl(path: string, origin: string): string {
  if (!origin) return path;
  return `${origin}${path.startsWith('/') ? path : `/${path}`}`;
}

/** `/blog?lang=fr` plutôt que `/blog` : la langue vit dans l'URL, pas dans un état React. */
export function pathWithLang(path: string, lang: Lang): string {
  return lang === DEFAULT_LANG ? path : `${path}?lang=${lang}`;
}
